import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import { performanceCn } from "../temp/performance-cn";
import trans from "@/doc/lang/_cn.json";
import hom from "@/doc/hom/_cn.json";
import { langCn } from "../lgyLangs/cn";
import { fhbLangCn } from "../fhbLangs/cn";
import { lssLangCn } from "../lssLangs/cn";
import { wrhLangCn } from "../wrhLangs/cn";
import { lxyLangCn } from "../lxyLangs/cn";
import { DyLangCn } from "../DyLangs/cn";


const cn = {
  normal: "正常",
  outsourcing: "委外",
  English: "英语",
  española: "西班牙语",
  India: "印地语",
  authority: {
    createNewUser: "新建用户",
    enterName: "请输入名字",
    enterEmail: "请输入邮箱 ",
    enterRole: "请输入角色 ",
    enterCountry: "请输入国家",
    enterID: "请输入员工号",
    enterPassword: "请输入密码 ",
    password: "密码 ",
    modifyPassword: "修改密码",
    oldPassword: "原密码",
    newPassword: "新密码",
    confirmPassword: "确认新密码",
    confirmTheChanges: "确认修改",
    ifForgotContactLeader: "如忘记密码，请联系组长",
    disaccordWithThFirsPassword: "两次密码不一致",
    passwordRules: "密码应包含大小写字母、数字、符号，不含用户名，至少8位字符",
    name: "名字",
    email: "邮箱 ",
    role: "角色 ",
    country: "国家",
    operator: "操作人 ",
    operate: "操作 ",
    Disable: "禁用",
    Enable: "启用",
    enableGoogleVerification: "启用谷歌验证 ",
    requiredFields: "必填项 ",
    pleaseFillInCorrectly: "请填写正确",
    edit: "编辑 ",
    delete: "删除 ",
    add: "新增",
    confirmDelete: "确定删除？ ",
    cancel: "取消 ",
    ok: "确定",
    search: "查询 ",
    operateTime: "操作时间 ",
    roleManagement: "角色管理",
    containsSubordinateLevelsAndCannotBeDeleted: "有附属层级，不能删除 ",
    addaFirstLevelRole: "新增一级角色",
    roleRightsManagement: "角色权限管理",
    permissionAssignment: "权限分配 ",
    operationAuthority: "操作权限 ",
    dataAuthority: "数据权限",
    pleaseEnteraKeyword: "请输入关键词 ",
    passwordVerification:
      "密码应包含大小写字母、数字、符号，不能用您的名字作为密码 ",
    passwordDoesNotContainCapitalLettersPleaseFillInAgain:
      "密码未包含大写字母，请重新填写",
    passwordDoesNotContainLowercaseLettersPleaseFillInAgain:
      "密码未包含小写字母，请重新填写 ",
    thePasswordDoesNotContainNumbersPleaseFillInAgain:
      "密码未包含数字，请重新填写 ",
    passwordDoesNotContainCharactersPleaseFillInAgain:
      "密码未包含字符，请重新填写",
    cantUseYourNameAsPasswordPleaseFillInAgain:
      "不能用您的名字作为密码，请重新填写 ",
    repeatPasswordPleaseFillInAgain: "重复密码，请重新填写 ",
    disaccordWithTheFirstPassword: "两次密码不一致",
    mailboxAlreadyExistsPleaseFillInAgain: "邮箱已存在，请重新填写",
    theRoleContainsUsersAndCannotBeDeleted: "角色中包含用户，不能删除 ",
    roleGroupManagement: "角色组管理 ",
    roleGroup: "角色组",
    createGroup: "新建小组 ",
    groupRoleAddedSuccessfully: "已成功添加组角色 ",
    roleExistsInRoleGroupDeletionFailed: "角色组内有角色，不能删除 ",
    groupPermissionManagement: "组权限管理",
    permissionAssignmentSucceeded: "权限分配成功 "
  },
  collectWorkOrders: {
    ticketAtttibuteConfiguration: "账期配置",
    singlePeriodDays: "账期配置（天数）-单期",
    installmentDays: "账期配置（天数）-分期",
    delete: "删除",
    save: "保存",
    addCustomWorkOrderLevels: "添加自定义工单等级",
    areYouSureToDelete: "确认删除此账单配置？",
    cancel: "取消",
    confirm: "确认",
    deleteAll: "全部删除",
    edit: "编辑",
    pleaseSetaCoherentLevel: "请设置连贯等级",
    pleaseSetaDifferentLevel: "请设置不同等级"
  },
  performance: {
    rollfinishnum: '展期结清数',
    staffPerformance: "人员绩效管理",
    ticketCategory: "工单分类",
    role: "角色",
    time: "选择时间",
    staff: "员工",
    email: "email",
    search: "搜索",
    clear: "清除",
    refresh: "刷新",
    export: "导出",
    date: "日期",
    ranking: "排名",
    totalLeftUnpaidPrincipal: "总金额",
    repayPrincipal: "回款本金",
    repayInterest: "回款息费",
    totalRepayAmount: "回款总金额",
    repayRate: "回收率",
    targetRepayRate: "目标回收率",
    diffTargetRepayAmount: "差值金额",
    newAssignNum: "新分配数",
    handleTimes: "处理工单次数",
    handleNum: "处理工单数",
    completeNum: "完成数",
    loadNum: "负载数",
    performanceComparison: "绩效对比",
    type: "绩效对比类型",
    belongedGroup: "所属组",
    staffOptional: "员工（可选填）",
    pleaseChoose: "请选择",
    YesNoLastorderrule: "是/否最后一次分单",
    byStaff: "按员工",
    byGroup: "按角色",
    byGroup1: "按角色",
    byGroup2: "按大组",
    byGroup3: "OM",
    pleaseChooseaRole: "选择一个角色",
    noStaffsUnderThisGroupWereFoundPleaseConfirmWhetherTheGroupAndStaffMatches:
      "未找到该组下成员，请确认组和员工名是否匹配",
    dashboard: "dashboard",
    groupTotalRepayAmount: "小组回款总金额",
    groupRepayRate: "小组回收率",
    groupKPI: "小组KPI",
    groupCompleteNum: "小组完成数",
    groupRanking: "小组当前排名",
    group: "小组",
    staffRanking: "本组组员排名",
    name: "姓名",
    newtab: "新标签打开",
    extensionFeeToNewOrde: "展期新订单入账",
    numberApplicationsRolloverOrders:'展期订单申请数',
    totalExtensionRepaymentAmount: "展期回款总金额",
    waiveOffAmount: "减免金额",
    waiveOffNum: "减免笔数",
    bonusAmount: "奖金",
    completeLabel: "是否完成绩效",
    completed: "已完成",
    inCompleted: "未完成",
    repayAmount: '回款金额',
    repayTime: '银行入账时间',
    notifyTime: '银行通知时间',
    jsIndex: '序号',
    businessTime: '业务方通知时间',
    answerNum: '接通量',
    answerTimes: '接通次数',
    pstClosureNum: '电销工单成交数',
    closureAmount: '成交额',
    pstClosureAmount: '电销成交额',
    conversionRate: '转化率',
    closureRate: '成交率',
    closureNum: '成交量'
  },
  performance2: {
    bucket: "催收案件分级",
    fecha: "时间日期",
    avgcalltime: "平均处理工单次数",
    difcalltime: "较上一小时平均处理工单次数差值",
    avgrepayrate: "实际回收率",
    hourlyachievementsents: "较上一小时回款率差额",
    totalallocationamount: "分案总金额",
    totalrepayamount: "回款总金额",
    hourlytarget: "目标回收率",
    completerate: "达成率"
  },
  orderInfo: {
    BadDebts: "坏账",
  },
  ticket: {
    ExportEmail: "邮件名单导出",
    Email: "邮箱",
    normal:'正常',
    abnormal:'异常',
    PaymentCodeStatus: "还款码状态",
    PowerNuclearRemarks: "电核备注",
    PaymentCodeAmount: "还款码金额",
    PaymentCode: "还款码",
    ThirdPartyName: "三方名称",
    Mobile: "手机号",
    VA: "VA",
    OXXOCode: "OXXO码",
    PaynetCode: "Paynet码",
    AccountId: "账户ID",
    InvalidTime: "失效时间",
    RemainingAmount: "剩余应还金额",
    collectTicketSystem: "催收工单系统",
    systemManager: "工单管理 ",
    ticketID: "工单ID ",
    loanID: "借款ID ",
    userID: "用户ID ",
    caseID: "caseID ",
    ticketAssignToName: "工单分配给（name） ",
    ticketAssignToId: "工单分配给（id） ",
    ticketCreateTime: "工单创建时间 ",
    completeTime: "完成时间 ",
    closeTime: "关闭时间 ",
    phoneSaleTag: "电销结果",
    assignTime: "分配时间 ",
    ticketStatus: "工单状态 ",
    orderStatus: "订单状态 ",
    ticketCategory: "工单分类 ",
    search: "查询 ",
    batchAssign: "批量分配 ",
    emailNameExport: "邮件名单导出",
    batchRecover: "批量回收 ",
    batchOutsourcing: "批量委外 ",
    batchRecall: " 批量收回自催 ",
    dataExport: "数据导出 ",
    manualUpgrade: "手动升级 ",
    handleTime: "处理工单次数 ",
    lastCommunicationResult: "上次处理时间 ",
    nextCommunicationResult: "下次沟通时间 ",
    partialCompleteTime: "部分完成时间 ",
    expirationTime: "过期时间 ",
    operation: "操作 ",
    attributeConfigure: "属性配置 ",
    ticketBasicAttribute: "工单基础属性 ",
    attributeNumber: "属性编号 ",
    attributeName: "属性名 ",
    foundTime: "创建时间 ",
    ticketCombineAttribute: "工单组合属性 ",
    newAttributeValueOperation: "新建属性+值操作 ",
    newCombineAttributeOperation: "新建组合属性操作 ",
    combineName: "组合属性名 ",
    attributeOne: "属性一 ",
    calculate: "运算 ",
    value: "值 ",
    attributeDetails: "属性明细 ",
    updateTime: "更新时间 ",
    edit: "编辑 ",
    loadAttributeConfigure: "负载属性配置 ",
    loadAttributeName: "负载属性名 ",
    attributeType: "属性值类型 ",
    combineAttributeNumber: "组合属性标号 ",
    attributeValue: "属性值 ",
    newTicket: "新工单 ",
    oldTicket: "旧工单 ",
    completeTicket: "已完成 ",
    telephone: "电话 ",
    customerName: "客户姓名 ",
    dailyCollectionTimes: "每日催收次数 ",
    collectionTimes: "催收次数 ",
    lastCollectionTime: "上次催收时间 ",
    lastCollectionRecord: "上次催收结果 ",
    promiseToPayTime: "承诺还款时间 ",
    customerType: "客户类型 ",
    overdueDays: "逾期天数 ",
    timeSinceLastProcessing: "距上次处理的时间 ",
    collection: "催收 ",
    ticketInfo: "工单信息 ",
    warning: "正在调查中，请停止催收！",
    LatestPromisedRepaymentTime: "上次承诺还款时间 ",
    customerDetailInformation: "客户详情 ",
    SMS: "短信 ",
    SMSContext: "短信内容",
    sendMessageToCustomer: "给本人发送短信 ",
    sendMessageToCustomer2: "给本人2发送短信 ",
    sendMessageToContactOne: "给联系人1发送短信 ",
    sendMessageToContactTwo: "给联系人2发送短信 ",
    sendMessageToContactThree: "给联系人3发送短信 ",
    selectMessage: "请选择短信模板 ",
    selectWAMessage: "请选择模板 ",
    send: "发送 ",
    phone: "电话 ",
    phoneTwo: "第二手机号",
    contact1phone: "联系人1-电话 ",
    relationship: "关系 ",
    name: "姓名 ",
    contact2phone: "联系人2-电话 ",
    contact3phone: "联系人3-电话 ",
    familyPhone: "家庭电话 ",
    autoCallResult: "自动外呼结果 ",
    logCollectionDetails: "记录催收结果 ",
    relief: "减免 ",
    contactWay: "联系方式 ",
    contactTime: "电话拨打时间 ",
    targetContact: "拨打对象 ",
    connection: "电话接通情况 ",
    willingnessToPay: "还款意愿 ",
    overdueReason: "逾期原因 ",
    ticketTag: "用户标签 ",
    collectionResult: "催收结果 ",
    remark: "备注 ",
    saveCollectionDetail: "保存催收记录 ",
    repaymentInfo: "还款信息 ",
    VAaccount: "VA账号 ",
    OXXOMarketPaymentCode: "OXXO便利店付款码",
    PaynetMarketPaymentCode: "Paynet便利店付款码",
    paymentlink: '还款链接',
    remainingAmountDue: "剩余应还 ",
    marketPayAmount: "便利店还款码金额",
    OXXOMarketPaymentCodeAmount: "OXXO便利店还款码金额 (包含手续费 ",
    PaynetMarketPaymentCodeAmount: "Paynet便利店还款码金额（包含手续费 ",
    refreshOXXOMarketPaymentCode: "更新便利店付款码金额 ",
    rcrefreshOXXOMarketPaymentCode: "还款请求生成",
    refreshOXXOMarketPaymentCodeen: "更新部分付款码金额",
    GetReference: '获取还款码',
    OXXONeedFee: "OXXO还款，用户还需要付款 手续费",
    PaynetNeedFee: "Paynet还款，用户还需要付款 手续费",
    PaycashNeedFee: "Paycash还款，用户还需要付款 手续费",
    BalotoNeedFee: "Vía Baloto还款，用户还需要付款 手续费",
    EfectyNeedFee: "Efecty还款，用户还需要付款 手续费",
    BancolombiaNeedFee: "Bancolombia还款，用户还需要付款 手续费",
    HandlingFee: "此处更新的还款金额不包含手续费和手续费 IVA，具体手续费和IVA 以工单页面为准",
    LoanInfo: "借款信息 ",
    SuggestInfo: "建议信息 ",
    RemainingAmountDue: "剩余应还总额 ",
    OverdueDays: "逾期天数 ",
    ActualRepaymentAmount: "实还总额 ",
    TotalRepaymentAmount: "账单总额 ",
    CollectionStaff: "提醒人 ",
    TargetContact: "拨打对象 ",
    CommunicationTools: "催收方式 ",
    Contact: "联系电话 ",
    ContactTime: "电话拨打时间 ",
    answerTime: "应答时间 ",
    endTime: "结束时间 ",
    hangupDirection: "挂机方向 ",
    hangupCause: "挂机原因 ",
    isNotConnect: "是否拨通 ",
    PromiseToPayTime: "承诺还款时间 ",
    WillingnessToRepay: "偿还意愿 ",
    CollectionResult: "未接通原因 ",
    record: "结果 ",
    DueDate: "应还日期 ",
    Principal: "应还本金 ",
    ReceivedRepaymentOfPrincipal: "已还本金 ",
    GracePeriodInterest: "应还宽限期利息 ",
    ReceivedRepaymentOfGracePeriodInterest: "已还宽限期利息 ",
    PenaltyAndExtraFeesThatShouldBePaid: "应还罚息 ",
    ReceivedRepaymentOfPenalty: "已还罚息 ",
    autoCallTime: "自动外呼时间",
    Nickname: "昵称",
    OnlineOrNot: "是否在线",
    UnprocessedTime: '未处理时间',
    Hour: '小时',
    MIN: '分钟',
    LastTimeWork: '最后一次处理工单时间',
    AreYouSure: "确定么",
    Sure: "确定",
    Cancel: "取消",
    DeductionOfPrincipal: "减免本金",
    InterestReduction: "减免息费",
    RecordCollectionResults: "记录催收结果",
    Connect: "接通",
    NotConnected: "未接通",
    LoanOrderNumber: "借款订单编号",
    Collection: "催收情况",
    RepaymentPlan: "还款计划",
    AutomaticOutgoingCallRecord: "自动外呼记录",
    Robotcallrecords: "机器人外呼记录",
    PaymentRecord: "回款记录",
    RecordCollectionRecord: "记录催收记录",
    RepaymentIssueReport: "还款问题上报",
    ApplyForInterestFreeze: "申请冻息",
    CommitmentRepaymentTime: "承诺还款时间",
    Reminder: "提醒人",
    CallObject: "拨打对象",
    CollectionMethod: "催收方式",
    ContactNumber: "联系电话",
    PhoneCallTime: "电话拨打时间",
    ResponseTime: "应答时间",
    EndTime: "结束时间",
    OnhookDirection: "挂机方向",
    ReasonForHangingUp: "挂机原因",
    WhetherToDial: "是否拨通",
    ReasonForNotReturning: "未还原因",
    ReasonForNotConnecting: "未接通原因",
    Result: "结果",
    Recording: "记录",
    AutomaticOutgoingTime: "自动外呼时间",
    WhetherToCommunicate: "是否沟通",
    EnterThePartialRepaymentAmount: "请录入与用户沟通的部分还款金额",
    Attention: "注意",
    RemainingAmountOfTheOrder: "订单剩余待还金额",
    OrderId: "订单id",
    BillId: "账单id",
    ActualPaymentDate: "实还日期",
    ActualRepaymentPrincipal: "实还本金",
    RemissionDay: "减免日期",
    ReferralDirector: "已减免本金",
    TheRemainingPrincipalCanBeReduced: "剩余可减免本金",
    Reason: "原因",
    ActualInterestPaidDuringGracePeriod: "实还宽限期利息",
    PenaltyInterestActuallyPaid: "实还罚息",
    GracePeriodInterestRemissiond: "已减免宽限期利息",
    RemissiondPenaltyInterest: "已减免罚息",
    TheRemainingPenaltyInterestCanBeRemission: "剩余可减免罚息",
    RemissionOfGracePeriodInterest: "减免宽限期利息",
    RemainingDeductibleInterestFromTheGracePeriod: "剩余可减免宽限期利息",
    auditResults: "审核结果",
    auditor: "审核员",
    ticketHandleTime: "工单处理时间",
    ticketCompleteTime: "工单完成时间",
    closeReason: "关闭原因",
    viewTicket: "查看工单",
    repayStatus: "上报状态",
    repayStatus0: "还款问题等待CS处理",
    repayStatus1: "等待银行/三方核实",
    repayStatus2: "可上传还款问题",
    tryCalc: "试算",
  },
  Dialer: {
    userName: "用户姓名",
    extnumber: "分机号码 ",
    assignStatus: "分配状态 ",
    assigned: "已分配 ",
    unassigned: "未分配 ",
    assign: "分配",
    assignHistory: "分配历史",
    supplier: "供应商 ",
    InquiryExtensionNumberStartRange: "查询分机号开始范围 ",
    InquiryExtensionNumberEndRange: "查询分机号结束范围 ",
    AccountNumberStartRange: "账号开始范围 ",
    AccountNumberEndRange: "账号结束范围 ",
    addTime: "添加时间 ",
    addTheExtensionNumber: "添加分机号码 ",
    deleteExtensionNumber: "删除分机号码 ",
    submit: "提交 ",
    roleList: "角色列表 ",
    unassign: "取消分配 ",
    assignStaff: "分配人员 ",
    staffID: "员工ID ",
    assignTime: "分配时间 ",
    unassignTime: "取消分配时间 ",
    calledNumber: "被叫号码",
    explicitNumber: "外显号码",
    Thelabelofintent: "意向标签",
    creationTime: "任务创建时间",
    outboundTime: "实际外呼时间",
    outboundChannels: "外呼渠道",
    talkTime: "通话时长",
    Callrecorddetails: "接通对话内容"
  },
  systemAttribute: {
    attributeName: "属性名",
    attributeDescription: "属性描述",
    parameterValue: "属性值",
    submit: "提交",
    NewSystemParameters: "新增系统参数"
  },
  phoneVerify: {
    workStatus: "工作状态",
    isAttendance: "是否出勤",
    batchOperations: "批量操作",
    orderTime: "接单时间",
    PVCommissioner: "pv专员",
    IRCommissioner: "IR专员",
    batchOrders: "批量接单",
    batchStopOrders: "批量停单",
    stopAcceptTicket: "暂停接单",
    continueAcceptTicket: "开始接单"

  },
  userInfo: {
    identityInformation: "身份信息",
    name: "客户姓名",
    gender: "性别",
    IDType: "证件类型",
    IDNumber: "证件ID号",
    mobileNumber: "手机号码",
    email: "邮箱",
    versionName: "客户端版本号",
    versionCode: "GP中的版本号",
    imageData: "图像资料",
    IDPhoto: "证件照片",
    handheldPhoto: "手持身份证照片",
    otherInformation: "其他信息",
    personalInfomation: "个人信息",
    marriageStatus: "婚姻",
    birthday: "出生日期",
    numberOfChildren: "有几个孩子",
    currentAddress: "当前住址",
    detailAddress: "详细地址",
    educationStatus: "教育",
    famialyPhone: "家庭电话",
    disbursementType: "收款方式",
    bankName: "银行名称",
    bankNumber: "银行卡号",
    workInformation: "工作信息",
    workType: "工作类型",
    monthlyIncome: "月收入",
    lengthOfWork: "工作多久",
    companyPhoneNumber: "公司电话",
    companyName: "公司名称",
    companyAddress: "公司所在城市（省、市）",
    salaryDay: "发薪日",
    contactInformation: "联系人信息",
    contact1Name: "联系人1姓名",
    contact1Relationship: "联系人1关系",
    phone: "电话",
    contact2Name: "联系人2姓名",
    contact2Relationship: "联系人2关系",
    communicationTime: "沟通时间",
    communicator: "沟通人",
    contents: "沟通内容",
    remark: "备注",
    loanHistory: "借款id",
    loanAmount: "借款金额",
    loanTerms: "沟通人",
    loanStatus: "借款状态",
    applyTime: "申请时间",
    processingTime: "审批时间",
    loanTime: "放款时间",
    amountNumber: "放款金额",
    closingTime: "结清时间",
    overdueDays: "逾期天数",
    ChangeHistory: "变更历史",
    BorrowingHistory: "借款历史",
    AccountNumber: "账号",
    UpdateItems: "更新项",
    OriginalValue: "原值",
    TheCurrentValue: "现值",
    TimeChange: "修改时间",
    ModifiedBy: "修改人",
    TheTerm: "期限",
    State: "状态",
    BillingMessage: "收款信息"
  },
  menu: {
    PaymentCodeList: "还款码列表",
    PaymentCodeHistory: "还款码历史",
    AuthoritySystem: "权限系统",
    UserManagement: "用户管理",
    RoleManagement: "角色管理",
    AuthorityManagement: "权限管理",
    RolegroupManagement: "角色组管理",
    GroupRightsManagement: "组权限管理",
    SystemParameterConfiguration: "系统参数配置",
    PhoneVerifySystem: "信审管理",
    StaffManagement: "员工管理",
    QuestionLibraryConfig: "信审问题库配置",
    CaseClassification: "案件分级",
    CollectTicketSystem: "催收工单系统",
    TicketManage: "工单管理",
    AttributeConfigure: "属性配置",
    TicketBasicAttribute: "工单基础属性",
    TicketCombineAttribute: "工单组合属性",
    LoadAttributeConfigure: "负载属性配置",
    RuleConfiguration: "规则配置",
    GenerationRule: "生成规则",
    DistributionRules: "分配规则",
    RecyclingRules: "回收规则",
    OutsourcingRules: "委外规则",
    WorkOrderProcessingList: "工单处理列表",
    QualityInspectionRecording:'录音质检工单管理',
    Collection: "催收",
    RecordingQuality:'录音质检列表',
    RepaymentReminder: "还款提醒",
    DialerManagement: "Dialer管理",
    VoipManagement: "voip管理",
    AutomaticOutgoingCallRecord: "自动外呼记录",
    NxManagement: "NX配置",
    ExtensionManagement: '分机管理',
    PerformanceManagement: "绩效管理",
    PersonalPerformance: "个人绩效",
    PersonalPerformance2: "小时催收数据",
    Project: '项目绩效',
    PerformanceComparison: "绩效对比",
    DistributeHistory: "分配历史",
    CollectionSystem: "C2 信贷业务中台",
    callRecords: "通话记录",
    PaymentCodeInquire: "还款码查询",
    salaryReport: "工资报表",
    Applyapprove: "申请审核",
    TelemarketingTicketSystem: "电销工单系统",
    OCRannotationmanagement:'OCR标注管理',
    OCRTicketList:"OCR工单列表",
    OCRlist:'OCR 列表',
    AssignTryCalc: "分配规则",
    WhatsAppManage:'whatsAPP管理',
    WhatsAppLogin:'whatsAPP账号管理',
    WhatsAppChat:'whatsAPP聊天',
    CorpusAnnotation:'语料标注',
    CorpusAnnotationDetail:'语料标注详情',
    CorpusAnnotationList:'语料标注列表',
    StaffBasicProperty: '员工基础属性',
    StaffCombProperty: '员工组合属性',
    Dashboard: '数据看板',
    DashboardScreen: '大屏看板',
    LoggingManagement: '日志记录',
    SystemOperationLog: '系统操作日志',
    ThirdPartyRequestLog: '三方请求日志',
    pageTips: '任何行为都有日志记录，请勿将公司数据私用，私用数据将被从严追责！'
  },
  lang: {
    Spanish: "Español",
    Chinese: "中文",
    English: "English",
    Vietnam: "Tiếng Việt",
    indo: "bahasa Indonesia",
    Arabic:' بالعربية ',
  },
  v0703: {
    Caseid: "案例ID",
    TicketOperate: "工单操作",
    PleaseEnterOrSelectRole: "请输入或选择角色",
    CreationTime: "创建时间",
    LoadAttributesName: "负载属性名称",
    PleaseEnterOrSelectAnAttributes: "请输入或选择一个属性",
    LoadAttributesNumber: "负载属性编号",
    LoadAttributesDescription: "负载属性说明",
    LoadAttributesType: "负载属性类型",
    CombinedPropertyName: "组合属性名称",
    NumericalValue: "数值",
    Options: "选项",
    Time: "时间",
    CrowdOrder: "绩效排名",
    Save: "保存",
    PleaseEnter: "请输入",
    TicketUnassign: "工单取消分配",
    ViopNumberUnassign: "分机号取消分配",
    NewAddition: "新增",
    TicketAssignStaff: "工单分配人员",
    TicketStaffId: "工单人员编号",
    TicketUnassignTime: "工单取消分配时间",
    ByDay: "按天",
    Hour: "按小时",
    ParameterValue: "参数值"
  },
  v0707: {
    FirstsubsequentLoan: "首复贷",
    FirstLoan: "首贷",
    Reloan: "复贷",
    Yes: "是",
    No: "否"
  },
  annotation: {
    AnnotationManagement: "标注管理",
    AnnotationTicketManagement: "标注工单管理",
    AnnotationTicketList: "标注工单列表",
  },
  smsPushTask: {
    multilingualTitle: "多语言标题",
    multilingualContent: "多语言内容",
    multilingualStatus: "多语言状态",
    label: "标签",
    state: "状态",
    addMultilingual: "新增多语言",
    multilingualDesc: "多语言描述",
    relateSmsTask: "关联短信任务",
    relatePushTask: "关联push任务",
    operator: "操作员",
    changeState: "修改状态",
    editContent: "编辑内容",
    addMultilingualContent: "添加多语言内容",
    selectLanguage: "选择语言",
    varLibrary: "变量库",
    multiContentManage: "多语言内容管理",
  },
  ...zhLocale,
  ...performanceCn,
  ...JSON.parse(trans),
  ...JSON.parse(hom),
  ...langCn,
  ...fhbLangCn,
  ...wrhLangCn,
  ...DyLangCn,
  ...lxyLangCn,
  ...lssLangCn
};

export default cn;
